import React, { ChangeEvent, RefObject } from "react";
import { AutoCompleteOption, InputType } from "../../shared/interfaces";
import Autocomplete from "./AutoComplete";

export interface InputFieldProps<T>
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  value?: string;
  displayLabel?: boolean;
  displayInput?: boolean;
  register?: any;
  error?: string;
  inputType?: InputType;
  options?: AutoCompleteOption[];
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  setSelected?: (value: AutoCompleteOption | null) => void;
  selected?: AutoCompleteOption | null;
  labelClassName?: string;
  inputRef?: RefObject<HTMLInputElement | null>;
}
const InputField = <T,>({
  label,
  name,
  value,
  displayLabel = true,
  displayInput = true,
  onChange,
  setSelected,
  className,
  register,
  inputType = InputType.TEXT,
  options,
  error,
  labelClassName,
  inputRef,
  ...rest
}: InputFieldProps<T>) => {
  return (
    <div className={`flex flex-col gap-[2px] mb-0 min-w-0 ${displayLabel ? 'w-full' : 'w-full min-w-0'}`}>
      <div className={`flex items-center gap-[3px] min-w-0 ${displayLabel ? 'w-full' : 'w-full min-w-0'}`}>
        {/* Render label only when displayLabel is true */}
        {displayLabel && (
          <label
            htmlFor={String(name)}
            className={`w-[4.75rem] sm:w-28 md:w-36 lg:w-48 shrink-0 font-medium ${labelClassName || "text-white"}`}
          >
            {label}
          </label>
        )}
        {displayInput && inputType === InputType.TEXT && (
          <input
            ref={inputRef}
            id={String(name)}
            name={String(name)}
            value={value}
            placeholder={label}
            onChange={onChange}
            className={`${displayLabel ? 'min-w-0 flex-1' : 'min-w-0 w-full box-border'} h-[30px] px-2 py-1 border border-gray-300 ${rest.disabled ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-white text-gray-900'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className || ""}`}
            {...rest}
          />
        )}
        {displayInput && inputType === InputType.AUTOCOMPLETE && (
          <div className="min-w-0 flex-1">
            <Autocomplete
              options={options || []}
              id={String(name)}
              placeholder={label + "..."}
              selected={rest.selected || null}
              setSelected={setSelected!}
              className={className || ""}
              inputRef={inputRef}
              {...rest}
            />
          </div>
        )}
        {displayInput && inputType === InputType.DATE && (
          <input
            type="date"
            id={String(name)}
            name={String(name)}
            value={value}
            placeholder={label}
            onChange={onChange}
            className={`min-w-0 flex-1 h-[30px] px-2 py-1 border border-gray-300 bg-white text-gray-900 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className || ""}`}
            {...rest}
          />
        )}
      </div>
      {/* Error message */}
      {error && (
        <div
          className={`text-red-500 text-sm mt-0.5 ${
            displayLabel ? "ml-[4.75rem] sm:ml-28 md:ml-36 lg:ml-48" : ""
          }`}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default InputField;
